// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"f2810661","593":"03f29a92"}[chunkId] + ".css";
};